import api from "@/services/api.service";

export default {
 name: 'show-conflict',
 components: {},
 props: {
  caption: {
    type: String,
    default: "Response Contact list"
  },
  hover: {
    type: Boolean,
    default: true
  },
  striped: {
    type: Boolean,
    default: true
  },
  bordered: {
    type: Boolean,
    default: false
  },
  small: {
    type: Boolean,
    default: false
  },
  fixed: {
    type: Boolean,
    default: false
  }
},
data() {
  return {
    contact_data: [],
    fields: [],
    conflict_data:[],  
    levelDiscription : {'ExachMacth':'','UpdateMatch': '','ConflictMatch': ''},        
    status:'',
    formField:[],     
    errorClass: 'bg-warning',
    permission_show: false,
    permission_editConflictResponse: false,
    permission_keepConflictResponse: false,
    superAdmin: false,
    md:"6",
    md1:"12"
  };
},
watch: {},
async created() {
  let response = await api.post("users/user-permissions");
    const permissions = [];
    if (response.status == "success") {
      response.data[0].permission.forEach( function(element) {                
          permissions.push(element.action)
      }.bind(this));
      if(permissions.includes("uploaded_response_details_view_event") == true){
        this.getMarketingResponseContacts();
        this.permission_show = permissions.includes("uploaded_response_details_view_event");
        this.permission_editConflictResponse = permissions.includes("uploaded_reponse_edit_event");
        this.permission_keepConflictResponse = permissions.includes("uploaded_reponse_edit_event");
      }else if(response.data[0].role == 'super_admin'){
        this.getMarketingResponseContacts();
        this.superAdmin = true;
      }else if(permissions.includes("uploaded_response_list_event") == true){
        this.makeToast("Permission denied","Alert","warning",6000);
        this.$router.push({name: 'Response'});
      }
      else if(permissions.includes("list_event") == true || permissions.includes("add_event") == true){
          this.makeToast("Permission denied","Alert","warning",6000);
          this.$router.push({name: 'List Event'});
      }else{
          this.makeToast("Permission denied","Alert","warning",6000);
          this.$router.push({name: 'Admin Dashboard'});
      }
    }
},
methods: {
  makeToast(message = "", title = "Alert", variant = "warning") {
    this.toastCount++;
    this.$root.$bvToast.toast(message, {
      title: title,
      variant: variant,
      autoHideDelay: 3000
    });
  },
  async getMarketingResponseContacts() {

    let response = await api.post("marketing-event/get-marketing-response-contacts", {id : this.$route.params.conflict_id});          
    if (!response)
      this.makeToast("Something went to wrong please try again","Alert","danger",6000);
    if (response.status == "success") {
      if (response.data.data != "") {  
        //GET ALL HEADERS FROM JSON        
        var columns = Object.keys(Object.assign({}, ...[JSON.parse(response.data.contact_data)]));        
        columns.map((h) => {
         this.fields.push({key: h})
       });
        this.fields.push({key:'total_score'},{key:'total_waightage'},{key:'total_score_per'},{key:'updates_on'});
        this.status = response.data.status;  
        //Iterate Data
        this.contact_data = JSON.parse(response.data.contact_data);//Object.assign({}, JSON.parse(response.data.contact_data), {id:response.data.id});
        this.formField = JSON.parse(response.data.contact_data);;//Object.assign({}, JSON.parse(response.data.contact_data), {id:response.data.id});
        this.conflict_data = JSON.parse(response.data.conflict_data);
        var cnt = 0;
        for (const k in this.conflict_data) {
            if(this.conflict_data[k].length > 0){
              cnt = cnt + 1;
            }
        } 
        if(cnt == 1){ this.md = '12'; this.md1 = '6';  }
      } else {
        this.items = [];
      }
    }else{
      this.makeToast(response.message, 'Alert', 'warning', 6000);
      this.$router.push({name: "List Event"});
    }      
    this.isBusy = false;
  },  
  async edit(){
    if(!this.formField.id){        
      this.makeToast('Please select any updateds on column','Validation','danger');
      return;
    }
    this.formField.conflict_id = this.$route.params.conflict_id;
    let response = await api.post('contact/edit-conflict-contact', this.formField);
    if (!response)
      this.makeToast("Something went to wrong please try again", 'Alert', 'danger', 6000)

    if (response.status == 'success') {
      this.makeToast(response.message, 'Success', 'success', 6000);
      this.$router.push({name: "Response",id:this.$route.params.id});
    } else {
      for (var error in response.errors) {
        this.makeToast(response.errors[error], 'Alert', 'danger');
      }
    }
  },
  async editNext(){
    if(!this.formField.id){        
      this.makeToast('Please select any updateds on column','Validation','danger');
      return;
    }
    this.formField.conflict_id = this.$route.params.conflict_id;
    let response = await api.post('contact/edit-conflict-contact', this.formField);
    if (!response)
      this.makeToast("Something went to wrong please try again", 'Alert', 'danger', 6000)

    if (response.status == 'success') {

        let responseNext = await api.post("marketing-event/editnext",{marketing_event_id: this.$route.params.id,response_id:this.$route.params.conflict_id});
        if(responseNext.status=='success'){
          this.makeToast(response.message, 'Success', 'success', 6000);
          return this.$router.push({name : "Show Conflict",params: {conflict_id:responseNext.data.id}});
        } else {
          this.makeToast(response.message, 'Success', 'success', 6000);
          this.makeToast("No response pending to resolve","Alert","warning",6000);
          this.$router.push({name: 'Response'});
        }
    } 
    else {
      for (var error in response.errors) {
        this.makeToast(response.errors[error], 'Alert', 'danger');
      }
    }
  },
  async keepBoth(){
    this.formField.conflict_id = this.$route.params.conflict_id;
    let response = await api.post('contact/add-conflict-contact', this.formField);
    if (!response)
      this.makeToast("Something went to wrong please try again", 'Alert', 'danger', 6000)

    if(response.status=='success'){
      this.makeToast(response.message,'Success','success');
      this.$router.push({ name: "Response Contacts" , params:{'id':this.$route.params.id}});
    }else{
      for(var error in response.errors){
        this.makeToast(response.errors[error],'Alert','danger');
      }
    }
  },
  async keepBothNext(){
    this.formField.conflict_id = this.$route.params.conflict_id;
    let response = await api.post('contact/add-conflict-contact', this.formField);
    if (!response)
      this.makeToast("Something went to wrong please try again", 'Alert', 'danger', 6000)

    if(response.status=='success'){
      
      let responseNext = await api.post("marketing-event/editnext",{marketing_event_id: this.$route.params.id,response_id:this.$route.params.conflict_id});
      if(responseNext.status=='success'){
        this.makeToast(response.message, 'Success', 'success', 6000);
        return this.$router.push({name : "Show Conflict",params: {conflict_id:responseNext.data.id}});
      } else {
        this.makeToast(response.message, 'Success', 'success', 6000);
        this.makeToast("No response pending to resolve","Alert","warning",6000);
        this.$router.push({name: 'Response'});
      }  
    }else{
      for(var error in response.errors){
        this.makeToast(response.errors[error],'Alert','danger');
      }
    }
  }
}
};
